import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { assetsAPI } from '../../../api';

export default function AssetScanRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Invalid scan link');
      return;
    }
    assetsAPI
      .scanByToken(token)
      .then((res) => {
        navigate(`/tenant/assets/${res.assetId}`, { replace: true });
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'Asset not found');
      });
  }, [token, navigate]);

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        {error ? (
          <p className="text-red-600 dark:text-red-400">{error}</p>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">Looking up asset…</p>
        )}
      </div>
    </Layout>
  );
}
